module.exports = __webpack_public_path__ + "static/media/settlements.6121e9b9.svg";